import classes from "./dropdown_base.module.css";

export default function DropdownBase({children, unselected, active, error, ...props}) {
    props.className = `${props.className} ${classes["dropdown-base"]} text-md-regular ${unselected ? "color-gray-500" : "color-gray-900"} ${active ? classes.active : ""} ${error ? classes.error : ""}`
    return <div {...props}>
        {children}
    </div>
}